import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getAbNormalListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/error/record/info',
    method: 'get',
    params
  })
}

// 监控管理
// 监控配置列表查询
export const configInfo = (params) => {
  return httpService({
    url: '/orion-api/monitor/config/info',
    method: 'get',
    params
  })
}
export const detail = (data) => {
  return httpService({
    url: '/orion-api/monitor/config/detail',
    method: 'put',
    data
  })
}

export const allot = (data) => {
  return httpService({
    url: '/orion-api/monitor/config/team/allot',
    method: 'post',
    data
  })
}

//  监控爬取异常列表查询
export const crawlinfo = (params) => {
  return httpService({
    url: '/orion-api/monitor/config/crawl/info',
    method: 'get',
    params
  })
}

// 监控爬取异常详情列表查询
export const exceptioninfo = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/crawl/info',
    method: 'get',
    params
  })
}

// 爬取异常状态变更
export const modifystatus = (data) => {
  return httpService({
    url: '/orion-api/exception/monitor/modify/crawl/status',
    method: 'put',
    data
  })
}

// 根据异常编号查询爬取异常日志列表信息
export const monitorinfo = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/log/crawl/info',
    method: 'get',
    params
  })
}

//  解析异常列表查询
export const parseinfo = (params) => {
  return httpService({
    url: '/orion-api/monitor/config/parse/info',
    method: 'get',
    params
  })
}

// 爬取异常状态变更
export const parsestatus = (data) => {
  return httpService({
    url: '/orion-api/exception/monitor/modify/parse/status',
    method: 'put',
    data
  })
}

// 监控解析异常详情列表查询(参考参考爬取异常详情列表查询)
export const monitorparseinfo = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/parse/info',
    method: 'get',
    params
  })
}

// 根据异常编号和异常类型查询解析异常日志列表信息
export const logparseinfo = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/log/parse/info',
    method: 'get',
    params
  })
}

// 日志列表查询
export const monitorloginfo = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/info',
    method: 'get',
    params
  })
}

// 异常详情原文查询
export const monitorcontent = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/content',
    method: 'get',
    params
  })
}

// 异常详情原文查询
export const monitorDocContent = (params) => {
  return httpService({
    url: '/orion-api/exception/monitor/document/content',
    method: 'get',
    params
  })
}

//  /orion-api/exception/monitor/log/status/

export const status = (params) => {
  return httpService({
    url: `/orion-api/exception/monitor/log/status/${params}`,
    method: 'get'
  })
}

export const monitorUrl = (params) => {
  return httpService({
    url: `/orion-api/exception/monitor/url`,
    method: 'get',
    params
  })
}
